import { IBlock } from '../models/block.model.i';

export const BLOCKS: Array<[number, IBlock]> = [
    [
        11,
        {
            id: 11,
            name: 'Gewerbehalle 1',
            latitude: 48.416944,
            longitude: 13.217222
        }
    ],
    [
        12,
        {
            id: 12,
            name: 'Gewerbehalle 2',
            latitude: 48.416944,
            longitude: 13.217778
        }
    ],
    [
        13,
        {
            id: 13,
            name: 'Gewerbehalle 3',
            latitude: 48.416944,
            longitude: 13.218056
        }
    ],
    [
        14,
        {
            id: 14,
            name: 'Gewerbehalle 4',
            latitude: 48.416944,
            longitude: 13.218611
        }
    ],
    [
        15,
        {
            id: 15,
            name: 'Gewerbehalle 5',
            latitude: 48.416944,
            longitude: 13.218889
        }
    ],
    [
        16,
        {
            id: 16,
            name: 'Gewerbehalle 6',
            latitude: 48.416944,
            longitude: 13.219444
        }
    ],
    [
        17,
        {
            id: 17,
            name: 'Freigelände Gewerbe (17)',
            latitude: 48.416667,
            longitude: 13.217778
        }
    ],
    [
        18,
        {
            id: 18,
            name: 'Freigelände Gewerbe (18)',
            latitude: 48.416667,
            longitude: 13.218611
        }
    ],
    [
        19,
        {
            id: 19,
            name: 'Freigelände Gewerbe (19)',
            latitude: 48.416667,
            longitude: 13.218056
        }
    ],
    [
        20,
        {
            id: 20,
            name: 'Freigelände Landtechnik (20)',
            latitude: 48.416667,
            longitude: 13.220000
        }
    ],
    [
        21,
        {
            id: 21,
            name: 'Freigelände Landtechnik (21)',
            latitude: 48.416944,
            longitude: 13.220556
        }
    ],
    [
        24,
        {
            id: 24,
            name: 'Freigelände Landtechnik (24)',
            latitude: 48.417222,
            longitude: 13.220278
        }
    ],
    [
        25,
        {
            id: 25,
            name: 'Freigelände Landtechnik (25)',
            latitude: 48.417500,
            longitude: 13.220278
        }
    ],
    [
        26,
        {
            id: 26,
            name: 'Freigelände Landtechnik (26)',
            latitude: 48.417778,
            longitude: 13.220556
        }
    ],
    [
        27,
        {
            id: 27,
            name: 'Freigelände Landtechnik (27)',
            latitude: 48.418056,
            longitude: 13.220556
        }
    ],
    [
        28,
        {
            id: 28,
            name: 'Agrarhalle (28)',
            latitude: 48.416667,
            longitude: 13.221111
        }
    ],
    [
        31,
        {
            id: 31,
            name: 'Freigelände Landtechnik (31)',
            latitude: 48.416389,
            longitude: 13.222222
        }
    ],
    [
        32,
        {
            id: 32,
            name: 'Freigelände Landtechnik (32)',
            latitude: 48.416944,
            longitude: 13.221667
        }
    ],
    [
        33,
        {
            id: 33,
            name: 'Freigelände Landtechnik (33)',
            latitude: 48.416944,
            longitude: 13.221944
        }
    ],
    [
        34,
        {
            id: 34,
            name: 'Freigelände Landtechnik (34)',
            latitude: 48.416944,
            longitude: 13.222222
        }
    ],
    [
        35,
        {
            id: 35,
            name: 'Freigelände Landtechnik (35)',
            latitude: 48.416944,
            longitude: 13.222500
        }
    ],
    [
        36,
        {
            id: 36,
            name: 'Freigelände Landtechnik (36)',
            latitude: 48.416944,
            longitude: 13.222778
        }
    ],
    [
        41,
        {
            id: 41,
            name: 'Freigelände Landtechnik (41)',
            latitude: 48.416944,
            longitude: 13.224167
        }
    ],
    [
        42,
        {
            id: 42,
            name: 'Freigelände Landtechnik (42)',
            latitude: 48.416944,
            longitude: 13.224444
        }
    ],
    [
        43,
        {
            id: 43,
            name: 'Freigelände Landtechnik (43)',
            latitude: 48.416944,
            longitude: 13.225000
        }
    ],
    [
        44,
        {
            id: 44,
            name: 'Freigelände Landtechnik (44)',
            latitude: 48.416944,
            longitude: 13.225278
        }
    ],
    [
        45,
        {
            id: 45,
            name: 'Freigelände Landtechnik (45)',
            latitude: 48.416111,
            longitude: 13.224444
        }
    ],
    [
        51,
        {
            id: 51,
            name: 'Freigelände Energie (51)',
            latitude: 48.416111,
            longitude: 13.216389
        }
    ],
    [
        52,
        {
            id: 52,
            name: 'Freigelände Energie (52)',
            latitude: 48.415833,
            longitude: 13.216389
        }
    ],
    [
        53,
        {
            id: 53,
            name: 'Freigelände Energie (53)',
            latitude: 48.415833,
            longitude: 13.215556
        }
    ],
    [
        54,
        {
            id: 54,
            name: 'Freigelände Energie (54)',
            latitude: 48.415833,
            longitude: 13.213889
        }
    ],
    [
        55,
        {
            id: 55,
            name: 'Freigelände Energie (55)',
            latitude: 48.415556,
            longitude: 13.214722
        }
    ],
    [
        56,
        {
            id: 56,
            name: 'Freigelände Energie (56)',
            latitude: 48.415556,
            longitude: 13.216389
        }
    ],
    [
        57,
        {
            id: 57,
            name: 'Freigelände Energie (57)',
            latitude: 48.415556,
            longitude: 13.214444
        }
    ],
    [
        58,
        {
            id: 58,
            name: 'Energiehalle (58)',
            latitude: 48.415833,
            longitude: 13.215833
        }
    ],
    [
        59,
        {
            id: 59,
            name: 'Freigelände Energie (59)',
            latitude: 48.415278,
            longitude: 13.216111
        }
    ],
    [
        71,
        {
            id: 71,
            name: 'Freigelände Landtechnik (71)',
            latitude: 48.416389,
            longitude: 13.221944
        }
    ],
    [
        72,
        {
            id: 72,
            name: 'Freigelände Landtechnik (72)',
            latitude: 48.416111,
            longitude: 13.221667
        }
    ],
    [
        73,
        {
            id: 73,
            name: 'Freigelände Landtechnik (73)',
            latitude: 48.416111,
            longitude: 13.222222
        }
    ],
    [
        74,
        {
            id: 74,
            name: 'Freigelände Landtechnik (74)',
            latitude: 48.415833,
            longitude: 13.222222
        }
    ],
    [
        75,
        {
            id: 75,
            name: 'Freigelände Landtechnik (75)',
            latitude: 48.415556,
            longitude: 13.222222
        }
    ],
    [
        76,
        {
            id: 76,
            name: 'Freigelände Landtechnik (76)',
            latitude: 48.415278,
            longitude: 13.222222
        }
    ],
    [
        81,
        {
            id: 81,
            name: 'Freigelände Landtechnik (81)',
            latitude: 48.416111,
            longitude: 13.223056
        }
    ],
    [
        82,
        {
            id: 82,
            name: 'Freigelände Landtechnik (82)',
            latitude: 48.415833,
            longitude: 13.223056
        }
    ],
    [
        83,
        {
            id: 83,
            name: 'Freigelände Landtechnik (83)',
            latitude: 48.415833,
            longitude: 13.223611
        }
    ],
    [
        84,
        {
            id: 84,
            name: 'Freigelände Landtechnik (84)',
            latitude: 48.415556,
            longitude: 13.539722
        }
    ],
    [
        85,
        {
            id: 85,
            name: 'Freigelände Landtechnik (85)',
            latitude: 48.415833,
            longitude: 13.223889
        }
    ],
    [
        86,
        {
            id: 86,
            name: 'Freigelände Landtechnik (86)',
            latitude: 48.415556,
            longitude: 13.223056
        }
    ],
    [
        87,
        {
            id: 87,
            name: 'Freigelände Landtechnik (87)',
            latitude: 48.415556,
            longitude: 13.223889
        }
    ],
    [
        88,
        {
            id: 88,
            name: 'Freigelände Landtechnik (88)',
            latitude: 48.415278,
            longitude: 13.223056
        }
    ],
    [
        89,
        {
            id: 89,
            name: 'Freigelände Landtechnik (89)',
            latitude: 48.415556,
            longitude: 13.224167
        }
    ]
];
